import { Component } from '@angular/core';

@Component({
  selector: 'mom-carousel-card-skeleton',
  templateUrl: 'carousel-card-skeleton.component.html',
  styleUrls: ['./carousel-card-skeleton.component.scss']
})
export class CarouselCardSkeletonComponent {}
